<template lang="html">
  <div class="box" v-if="isShow">
    <!-- <img class="logo" src="../../assets/images/columnLogo.svg" alt=""> -->
    <h3 class="title">手机登录</h3>
    <span class="tip">OneFosun员工输入手机号进行登录</span>

    <div class="form-item" tabindex="0">
      <span @click="updateShowPhone" class="form-item-label">+{{countryCode}}</span>
      <img @click="updateShowPhone" class="form-item-image" src="../../assets/images/down.svg" alt="">
      <input class="form-item-input" type="text" name="" maxlength="11" v-model="phoneNumber" placeholder="填写手机号登入/注册">
    </div>
    <div class="form-item"  tabindex="1">
      <input class="form-item-input"  type="text" name="" v-model="code" placeholder="填写验证码">
      <span class="form-item-prefix" v-if="sendCode === 0" @click="getCode" >{{label}}</span>
      <span class="form-item-prefix" v-else-if="sendCode > 0 && seconds !== 60" style="color: rgba(60, 60, 67, 0.18)">{{`重新发送(${seconds})`}}</span>
      <span class="form-item-prefix" v-else @click="getCode" style="color: rgba(51, 51, 51, 1);">重发验证码</span>
      <span v-if="codeLabel"></span>
    </div>

    <div class="login" :style="{background: (code.length === 6) ? 'linear-gradient(165deg,rgba(2,121,221,1) 0%,rgba(28,232,182,1) 100%)' : 'rgba(229,229,234,1)'}" @click="login">
      <img src="../../assets/images/long-right.svg" alt="">
    </div>
    <span :style="{ bottom: isAndroid ? '18px' : `${ 18 + safeHeight }px` }" class="login-footer">星圈 - 复星生态下的互动、交流、学习平台</span>
    <Tip v-if="error" @closeModel="closeModel" :label="errorLabel" />
    <SelectPhone v-show="showCountry" :value="countryCode"  @change="selectPhone"/>
  </div>
</template>

<script>
/* eslint-disable */
import dd from 'DD'
import { post, get } from '../../utils/request'
import Tip from '../../components/message.vue'
import { set, get as getItem } from '../../utils/token'
import { safeHeight } from '../../utils/config'
import { isAndroid } from '../../utils/utils'
import { createNamespacedHelpers } from 'vuex'
import SelectPhone from '../../components/SelectPhone.vue'
// import Cookies from 'js-cookie'
import { getUserPower } from '../../utils/power'
const { mapActions } = createNamespacedHelpers('user')
let time = 0
const _user = getItem('user')
export default {
  components: {
    Tip,
    SelectPhone
  },
  mounted () {
    // const promise = getUser()
    // promise.then(res => {
    //   alert(JSON.stringify(res))
    // })
  },
  data () {
    return {
      isShow: dd.env.platform === 'notInDingTalk' || false,
      countryCode: '86',
      showCountry: false,
      code: '',
      label: '',
      sendCode: 0,
      codeLabel: '',
      seconds: 60,
      errorLabel: '',
      error: false,
      phoneNumber: '',
      password: _user && _user.password ? _user.password : '',
      nickName: '',
      username: _user && _user.username ? _user.username : '',
      loading: false,
      loadingLabel: 6,
      isAndroid: isAndroid(),
      safeHeight: safeHeight
    }
  },
  methods: {
    updateShowPhone () {
      this.showCountry = !this.showCountry
    },
    selectPhone (phone) {
      this.countryCode = phone
      this.updateShowPhone()
    },
    ...mapActions({
      updateUser: 'updateUser'
    }),
    validPhone (phone = this.phoneNumber) {
      // phone = phone.replace(/\s+/g, '')
      // const reg = /^[1][3,4,5,7,8,9][0-9]{9}$/
      // return reg.test(phone)
      return phone.length > 0
    },
    changeNumber () {
      clearTimeout(time)
      if (this.loadingLabel < 1) {
        this.loadingLabel = 6
        this.loading = false
        return
      }
      --this.loadingLabel
      time = setTimeout(() => {
        this.changeNumber()
      }, 1000)
    },
    countDown () {
      clearTimeout(time)
      if (this.seconds < 1) {
        this.label = '发送验证码'
        this.seconds = 60
        return
      }
      --this.seconds
      this.sendCode++
      time = setTimeout(() => {
        this.countDown()
      }, 1000)
    },
    changeCode (code) {
      if (code.length > 6) {
        this.error = true
        this.errorLabel = '验证码不得超过六位'
        return
      }
      this.setState({
        code: code
      })
    },
    goMlegal () {
      this.$router.push('/mlegal')
    },
    getCode () {
      this.countDown()
      const promise = post({
        url: '/user/getCode',
        data: {
          phoneNumber: this.phoneNumber,
          countryCode: this.countryCode
        }
      })
      promise.then(() => {
        /* eslint-disable-next-line */
      })
    },
    getRandomNickName () {
      const promise = get({
        url: '/user/generateNickname'
      })
      promise.then(res => {
        const { data: { nickName }, status } = res
        if (Object.is(status, 200)) {
          this.nickName = nickName
        }
      })
    },
    closeModel () {
      this.error = false
    },
    login () {
      const { phoneNumber, code } = this
      const promise = post({
        url: '/user/login',
        data: {
          code,
          phoneNumber
        }
      })
      promise.then(async res => {
        const { message, detail } = res.data
        if (message.indexOf('成功') !== -1) {
          set('X-Auth', detail.token)
          set('user', detail)
          set('mobile', phoneNumber)
          // Cookies.set('mobile', phoneNumber, {
          //   domain: ROOT
          // })
          this.updateUser(detail)
          await getUserPower()
          await this.$router.back()
          // console.log('this.$route1r', this.$route)
          // setTimeout(() => {
          //   console.log('this.$router', this.$route)
          //   this.$router.go()
          // }, 10)
          // const route = this.$router
          // console.log(route.history)
          // console.log('history', history)
          // window.location.href = '/'
        } else {
          this.error = true
          this.errorLabel = message
        }
      }).catch(function(){
        console.log('服务异常')
      })
    }
  },
  computed: {
  },
  watch: {
    phoneNumber: function () {
      let label = ''
      const show = this.validPhone()
      if (show) {
        label = '发送验证码'
      } else {
        label = ''
      }
      this.label = label
    },
    code: function (code) {
      if (code.length > 6) {
        this.code = this.code.substr(0, 6)
        return
      }
      this.code = code
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-popper[x-placement^=bottom] {
  z-index: 999999 !important;
}
body {
  background-color: #fff;
}
span {
  text-overflow: initial;
  overflow: initial;
}
.box{
  width: 300px;
  background: #fff;
  margin: 13.55vh auto 0 auto;
  .title{
    font-size:34px;
    font-family:PingFangSC-Semibold,PingFang SC;
    font-weight:600;
    color:rgba(51,51,51,1);
    line-height:41px;
  }
  .tip {
    font-size:13px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(60,60,67,0.6);
    line-height:18px;
    margin-top: 48px;
    margin-bottom: 16px;
    display: block;
  }
  .logo {
    width: 100px;
    height: 150px;
    margin: 0 auto 48px;
    display: block;
  }
  .header {
    display: flex;
    height: 41px;
    font-size: 34px;
    font-family:PingFangSC-Semibold,PingFang SC;
    font-weight:600;
    color:rgba(51,51,51,1);
    line-height: 41px;
    margin-bottom: 98px;
  }
  .desc {
    display: flex;
    height: 18px;
    font-size: 13px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(60,60,67,0.6);
    line-height: 18px;
  }
  .form-item {
    width: 300px;
    margin-top: 16px;
    height: 49px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 13px 16px;
    border-radius: 8px;
    outline:none;
    flex: 1;
    border:1px solid rgba(229,229,234,1);
    .form-item-label {
      font-size: 17px;
      font-family:SFProText-Regular,SFProText;
      font-weight:400;
      color:rgba(51,51,51,1);
    }
    .form-item-image{
      width: 6px;
      height: 6px;
      margin: 0 8px;
    }
    .form-item-input {
      width: 100%;
      font-size: 17px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight: bold;
      border: none;
      outline:none;
      &::-webkit-input-placeholder {
        font-weight:400;
        color:rgba(60,60,67,0.3);
      }
    }
    &:hover {
      border-color: rgba(51, 51, 51, 1);
    }
    .form-item-prefix {
      font-size: 16px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(24,204,159,1);
      white-space: nowrap;
      text-overflow: initial;
      overflow: initial;
    }
  }
  .random {
    color: rgba(95, 184, 120, 1);
    margin-top: 20px;
    display: block;
    cursor: pointer;
  }
  .login-button{
    margin-top: 16px;
    width: 300px;
    text-align: center;
    border-radius: 8px;
    border:1px solid rgba(229,229,234,1);
    padding: 5px 0;
    font-size: 18px;
  }
  .login {
    width: 88px;
    height:88px;
    border-radius: 50%;
    background:rgba(229,229,234,1);
    margin: 32px auto 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    image {
      width: 29.86px;
      height: 29.86px
    }
  }
  .footer {
    position: fixed;
    bottom: 36px;
    left: 0;
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
    font-size: 12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(51,51,51,1);
    .bold {
      font-weight: bold;
      margin-left: 3px;
    }
  }
  .login-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw;
    text-align: center;
    height:16px;
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(136,136,136,1);
    line-height:16px;
  }
}
</style>
